export interface UserEditorData {
  id: number
  userName: string
  possibleUserClassifications: UserClassificationInfo[]
  possibleCustomerRecords: CustomerInfo[]
  possibleBrokers: UserInfo[]
  cust: CustomerInfo
  userClassification: UserClassificationInfo
  emailAddress: string
  isAdmin: boolean
  isBackOffice: boolean
  isBroker: boolean
  doNotAddToAD: boolean
  ableToSeeTradersTheyCover: boolean
  isWebUser: boolean
  ableToSeeAllTradersAtFirm: boolean
  logonName: string
  loginPassword: string
  automaticallyEnabledNewAccounts: boolean
  subAccounts: SubAccountInfo[]

  broker1A: UserInfo
  broker1APct: string
  broker1B: UserInfo
  broker1BPct: string
  broker1C: UserInfo
  broker1CPct: string

  broker2A: UserInfo
  broker2APct: string
  broker2B: UserInfo
  broker2BPct: string
  broker2C: UserInfo
  broker2CPct: string

  broker3A: UserInfo
  broker3APct: string
  broker3B: UserInfo
  broker3BPct: string
  broker3C: UserInfo
  broker3CPct: string

  salesPersonWhoCovers1: UserInfo
  salesPersonWhoCovers2: UserInfo
  salesPersonWhoCovers3: UserInfo

  currencies: string[]
  validMACs: string
  bloombergUUID: string
  qr: string
  canRunReport: boolean
  highlightWhenNotLogged: boolean
  markAsDeleted: boolean
  lastClickThroughVersion: string
  defaultFIXAccountAlias: string
  maxSingleOrderLimit: string
}

export interface UserClassificationInfo {
  userClassId: number
  userClassName: string
}

export interface CustomerInfo {
  id: number
  customerName: string
}

export interface UserInfo {
  userId: number
  userName: string
}

export const NoBrokerSet: UserInfo = { userId: 0, userName: '' }

export interface SubAccountInfo {
  custId: number
  custName: string
  description: string
  enabled: boolean
  isDefault: boolean
}
